namespace TotalPoll {
    import Component = TotalCore.Common.Component;

    @Component('components.totalpoll', {
        templateUrl: 'welcome-component-template',
        bindings: {}
    })
    class WelcomeComponent {
        public constructor(private $scope) {

        }
    }
}
